import { Box, Card, CardActionArea, CardContent, List, ListItem, Stack, Typography } from '@mui/material';
import { BlogPageProps } from '../../../../pages/blog';
import { PostAuthor } from './PostAuthor';
import { PostSummary } from './PostSummary';
export const PostsListDesktop = ({
  posts
}: BlogPageProps) => <List sx={{
  display: 'grid',
  gridTemplateColumns: {
    sm: 'repeat(2, 1fr)',
    md: 'repeat(3, 1fr)'
  },
  gap: {
    xs: 2,
    md: 3,
    lg: 6
  }
}} data-sentry-element="List" data-sentry-component="PostsListDesktop" data-sentry-source-file="PostsListDesktop.tsx">
    {posts.results.map(post => {
    const {
      authorFetchedName,
      authorAvatar,
      featuredImage,
      featuredImageAltText,
      publishDate,
      postReadTime,
      slug,
      postSummary,
      htmlTitle
    } = post;
    return <ListItem key={post.id} disablePadding>
          <Card variant="elevation" elevation={6} sx={{
        height: '100%'
      }}>
            <CardActionArea href={`/${slug}`} aria-label={`Read ${htmlTitle}`} sx={{
          height: '100%',
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          gap: 2
        }}>
              <Box sx={{
            position: 'relative',
            height: 180,
            width: '100%',
            flexShrink: 0
          }}>
                <img src={featuredImage} alt={featuredImageAltText} style={{
              objectFit: 'contain',
              position: 'absolute',
              height: '100%',
              width: '100%',
              left: 0,
              top: 0,
              right: 0,
              bottom: 0
            }} />
              </Box>
              <CardContent component={Stack} direction="column" justifyContent="space-between" spacing={1.5} sx={{
            height: '100%',
            p: 0
          }}>
                <Typography variant="bodySmall">{`${postReadTime} min read`}</Typography>
                <Typography component="h2" variant="h4" sx={{
              m: 0
            }}>
                  {htmlTitle}
                </Typography>
                <PostSummary postSummaryHtml={postSummary} />
                <PostAuthor authorName={authorFetchedName} authorAvatar={{
              src: authorAvatar,
              size: 32
            }} publishDate={publishDate} />
              </CardContent>
            </CardActionArea>
          </Card>
        </ListItem>;
  })}
  </List>;